var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.993,
    height: 12.786,
    viewBox: "0 0 8.993 12.786",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5793",
    "data-name": "Grupo 5793",
    transform: "translate(8.993 12.786) rotate(180)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8473",
    "data-name": "Caminho 8473",
    d: "M4.95,3.61,8.011,6.637A.748.748,0,0,1,6.955,7.7L5.64,6.377c-.22-.221-.4-.147-.4.163v5.5a.747.747,0,1,1-1.493,0V6.54c0-.309-.178-.383-.4-.163L2.038,7.7A.748.748,0,0,1,.982,6.637L4.018,3.612a.663.663,0,0,1,.932,0ZM.749,1.5a.749.749,0,1,1,0-1.5H8.243a.749.749,0,0,1,0,1.5Z",
    transform: "translate(0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.afdac84c8155473b25cf51f04fbaa659.svg";
export { ForwardRef as ReactComponent };